import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

const MIN_COL: number = 2;
const MIN_GAP: number = 3;
const MIN_PAD: number = 4;

@Component({
  selector: 'app-bento-grid',
  template: `
    <div class="tw-w-full tw-grid"
         role="grid"
         [attr.aria-label]="ariaLabel"
         [class]="'tw-px-' + padding + ' tw-pb-' + padding + ' tw-gap-' + gap"
         [ngStyle]="{'grid-template-columns': 'repeat(' + columns + ', minmax(0, 1fr))'}">
      <ng-content></ng-content>
    </div>
  `,
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BentoGridComponent {
  @Input() columns: number = MIN_COL;
  @Input() gap: number = MIN_GAP;
  @Input() padding: number = MIN_PAD;
  @Input() ariaLabel: string = 'Content grid';
}
